import React from 'react';
import { CheckIcon, LockKeyholeIcon, MonitorSmartphoneIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton, Section } from './Shared';
import { KanjiBackdrop, Seal } from './Ornaments';
const benefits = [{
  icon: MonitorSmartphoneIcon,
  label: 'PDF para leer en tablet o computadora'
}, {
  icon: ZapIcon,
  label: 'Acceso digital'
}, {
  icon: LockKeyholeIcon,
  label: 'Pago seguro con Mercado Pago'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function Pricing() {
  const reduceMotion = useReducedMotion();
  return <Section id="pricing" className="my-4 rounded-2xl border border-stone-200 bg-white shadow-lg" data-id="element-201" data-mp="25t0utnvbij91">
      <KanjiBackdrop glyphs={['書', '庫', '術', '道', '傳']} data-id="element-202" data-mp="20sd658ukaehz" />
      <div className="mx-auto max-w-2xl text-center" data-id="element-203" data-mp="3h74lol6lzr9v">
        <span className="inline-flex items-center gap-2 rounded-full bg-red-700 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-204" data-mp="3h5tlevcdh1ni">
          <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-205" data-mp="3vzymkg4n372k" />
          Oferta de lanzamiento
        </span>
        <h2 className="mt-5 text-3xl font-bold tracking-tight text-stone-900 md:text-5xl" data-id="element-206" data-mp="4scnl0sv7ss1">
          TU <span className="text-red-700" data-id="element-207" data-mp="9rz0180vd4zs">BIBLIOTECA DE ESTUDIO</span> MTC
        </h2>
        <p className="mt-3 text-sm font-semibold uppercase tracking-[0.12em] text-amber-700 md:text-base" data-id="element-208" data-mp="er1yuaq9aezb">
          6 tomos principales + 3 bonus gratuitos
        </p>
        <p className="mt-1 text-sm text-stone-500 md:text-base" data-id="element-209" data-mp="3d6usitnies7f">
          450 páginas en PDF
        </p>
      </div>

      <div className="mx-auto mt-9 max-w-2xl" data-id="element-210" data-mp="3n750nzuot9fq">
        <div className="rounded-xl border-2 border-amber-300 bg-amber-50/40 p-5 shadow-md md:p-7" data-id="element-211" data-mp="3n6d8z047nvuq">
          <div className="flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-212" data-mp="3ryn20p0mhc18">
            <div className="flex gap-4" data-id="element-213" data-mp="2uhekll9hvxgz">
              <Seal characters="中醫" className="h-10 w-10 text-[11px]" data-id="element-214" data-mp="2ugn29c4wrw8n" />
              <div data-id="element-215" data-mp="2zfzpvz3lt7ca">
                <h3 className="text-xl font-bold tracking-tight text-stone-900" data-id="element-216" data-mp="2zfg4g8eqw0ti">
                  KIT MEDICINA TRADICIONAL CHINA™
                </h3>
                <p className="mt-3 max-w-lg text-sm font-medium leading-relaxed text-emerald-700" data-id="element-217" data-mp="2mgqillsygxmg">
                  Una biblioteca visual de estudio para terapeutas y practicantes
                  con formación previa que quieren ampliar sus conocimientos,
                  explorar distintas ramas y llevar su práctica al siguiente nivel.
                </p>
              </div>
            </div>
            <p className="shrink-0 text-left text-3xl font-bold tracking-tight text-red-700 sm:text-right" data-id="element-218" data-mp="23jz37ngjb2no">
              ARS 24.990
            </p>
          </div>
        </div>
        <motion.div animate={reduceMotion ? undefined : {
        y: [0, -2, 0]
      }} transition={{
        duration: 2.8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mt-6" data-id="element-219" data-mp="2dhdaawgkif3b">
          <CTAButton fullWidth className="py-5 md:text-xl" data-id="element-220" data-mp="3ows4xtlb0uv9">
            → QUIERO MI KIT MTC POR $24.990
          </CTAButton>
        </motion.div>
        <ul className="mt-5 grid gap-2 sm:grid-cols-2" aria-label="Beneficios de compra" data-id="element-221" data-mp="92g0n9zafqb">
          {benefits.map(benefit => <li key={benefit.label} className="flex items-center gap-2 rounded-lg border border-stone-200 bg-stone-50 px-3 py-3 text-[11px] font-semibold leading-tight text-stone-700 md:text-xs" data-id="element-222" data-mp="57dtd7zhf8da">
              <CheckIcon className="h-4 w-4 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-223" data-mp="3rirgpjw9pble" />
              <benefit.icon className="h-4 w-4 shrink-0 text-amber-700" aria-hidden="true" data-id="element-224" data-mp="j2yabxvnhgi2" />
              {benefit.label}
            </li>)}
        </ul>
      </div>
    </Section>;
}